import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/common/Sidebar';
import TopNavbar from '../../components/common/TopNavbar';
import SessionTimeoutManager from '../../components/session/SessionTimeoutManager';

export default function MainLayout() {
  return (
    <div className="flex h-screen bg-gray-50">
      <SessionTimeoutManager />
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <TopNavbar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
